import { bodyAtFaultFunction } from '@/common/queries/selections/bodyAtFault/bodyAtFaultQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const bodyAtFaultQueryOptions = () => {
  return queryOptions({
    queryKey: ['bodyAtFault'],
    queryFn: () => bodyAtFaultFunction(),
    select: (data) => {
      return data?.map((item) => ({
        label: item?.fa_const,
        value: item?.const,
      }));
    },
  });
};
